import Swiper, { Navigation } from 'swiper'

export const reviews = () => {
  const reviewBlocks = Array.from(document.querySelectorAll('.reviews'))

  const swiper = new Swiper('.swiper-reviews', {
    modules: [Navigation],
    navigation: {
      nextEl: '.review-block-next',
      prevEl: '.review-block-prev',
    },
    slidesPerView: 'auto',
    spaceBetween: 22,
    breakpoints: {
      768: {
        spaceBetween: 34,
      },
    },
    loop: true,
  })

  const swiperSingle = new Swiper('.swiper-reviews-slider', {
    modules: [Navigation],
    navigation: {
      nextEl: '.review-slider-next',
      prevEl: '.review-slider-prev',
    },
    slidesPerView: 1,
    loop: true,
  })

  reviewBlocks.forEach((block) => {
    const tabs = Array.from(block.querySelectorAll('.reviews__tabs button'))
    const reviews = Array.from(block.querySelectorAll('.reviews__list'))

    tabs.forEach((button, index) => {
      button.addEventListener('click', () => {
        tabs.forEach((b) => b.classList.remove('active'))
        reviews.forEach((b) => b.classList.remove('active'))

        button.classList.add('active')
        reviews[index].classList.add('active')
      })
    })
  })
}
